import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 海外结算中心，分公司确认查询
export function queryClearHistoryPageableFast(data) {
  return request({
    url: URL.act.clearHistory.queryClearHistoryPageableFast,
    method: 'post',
    data
  })
}

// 海外结算中心，批量确认
export function batchConfirm(data) {
  return request({
    url: URL.act.clearHistory.batchConfirm,
    method: 'post',
    data
  })
}
// 海外结算中心，批量拒绝
export function batchReject(data) {
  return request({
    url: URL.act.clearHistory.batchReject,
    method: 'post',
    data
  })
}
